<!--
 * @Author: your name
 * @Date: 2020-08-31 23:23:45
 * @LastEditTime: 2022-11-03 14:52:14
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/components/Collapse/index.vue
-->
<style scoped lang="sass">
.van_collapse_item_custom
  ::v-deep
    .van-cell
      align-items: center
      background: #f3f4f5
      padding-top: 7px
      padding-bottom: 7px
    // Sections that must stay open are not clickable, but they should not look
    // broken either — keep the normal header colours instead of vant's greyed
    // "not-allowed" styling.
    // 恒展开的分组不可点击，但不应显示成"被禁用"的灰色样式
    .van-collapse-item__title--disabled
      cursor: default
      &:active
        background: #f3f4f5
::v-deep
  .van_collapse_item_custom .van-cell
    height: 55px

.wrap
  line-height: 20px
  .small
    position: absolute
    top: 26px
    font-size: 10px
    line-height: 20px
    color: var(--menu-primary-text-colour)

.position
  height: 20px
  line-height: 20px

.title
  color: var(--menu-primary-text-colour)
</style>
<template lang="pug">
  van-collapse(v-model="collapseActiveNames" ref="collapseRef" accordion :border="false" @change="onChange")
    van-collapse-item(:name="name" class="van_collapse_item_custom" :disabled="lockOpen" :is-link="!lockOpen")
      template(#title)
        section.wrap
          .title {{ title }}
          .small(v-if="desc") {{ desc }}
          .position(v-if="desc")

      icon(slot="right-icon" :color="color" v-if="!lockOpen && (collapseActiveNames === '' || collapseActiveNames === null)") keyboard_arrow_up
      icon(slot="right-icon" :color="color" v-else-if="!lockOpen") keyboard_arrow_down
      slot
</template>

<script>
export default {
  computed: {
    color() {
      return this.$store.state.app.color.menu_primary_background_colour
    }
  },

  props: {
    title: String,
    desc: String,
    open: { // Expand by default   // 是否要设置为默认展开内容
      type: Boolean,
      default: true
    },
    // Always keep this section open and hide the toggle arrow.
    // Used for sections the customer has to fill in, so they can never be
    // hidden by accident.
    // 恒展开且隐藏折叠箭头（必选组用），顾客无法手动折叠
    lockOpen: {
      type: Boolean,
      default: false
    },
    name: [String, Number],
    index: {
      type: [String, Number],
      default: 0
    },
    id: [Number, String]
  },

  data() {
    return {
      value: 0,
      collapseActiveNames: ''
    }
  },

  watch: {
    index: {
      async handler(val) {
        await this.$nextTick()
        if (this.open || this.lockOpen) this.collapseActiveNames = val
      },
      immediate: true
    }
  },

  methods: {
    onChange(val) {
      this.value = val
      this.$emit('change', val)
    },
  },
}
</script>
